import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/warning.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[11000] flex items-center justify-center bg-black/50"
}
const _hoisted_2 = { class: "bg-white rounded-lg shadow-lg w-full max-w-2xl p-5" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_4 = { class: "text-sm text-gray-600 mt-4 text-center" }
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = { class: "mt-5 pt-4 text-left" }
const _hoisted_7 = { class: "flex items-center gap-3 border border-lightgrey rounded-md px-3 py-2.5" }
const _hoisted_8 = { class: "h-9 w-9 rounded border border-lightgrey flex items-center justify-center shrink-0 bg-white overflow-hidden" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "text-xs font-semibold text-darkblue"
}
const _hoisted_11 = { class: "text-sm text-darkblue font-medium flex-1 truncate" }
const _hoisted_12 = { class: "flex items-center justify-end pt-4 mt-2 border-t border-lightgrey" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "pt-2 pb-2" }
const _hoisted_15 = { class: "controls-scroll border border-lightgrey rounded-md overflow-y-auto max-h-40" }
const _hoisted_16 = { class: "task-id-cell text-sm text-primary font-semibold" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "task-title-cell text-sm text-darkblue" }
const _hoisted_20 = { class: "task-due-date-cell text-sm text-darkblue shrink-0" }
const _hoisted_21 = { class: "flex items-center justify-end pt-3 border-t border-lightgrey gap-2" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "pt-2 pb-2" }
const _hoisted_24 = { class: "controls-scroll border border-lightgrey rounded-md overflow-y-auto max-h-40" }
const _hoisted_25 = { class: "h-8 w-8 rounded border border-lightgrey flex items-center justify-center shrink-0 bg-white overflow-hidden" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "text-xs font-semibold text-darkblue"
}
const _hoisted_28 = { class: "text-sm text-darkblue" }
const _hoisted_29 = { class: "flex items-center justify-end pt-3 border-t border-lightgrey gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.mode === 'loading')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_dots_loader),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.loadingMessage), 1)
                ]))
              : (_ctx.mode === 'success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", {
                      class: "h-1 -mt-5 -mx-5 mb-5 rounded-t-lg",
                      style: {"background-color":"#1976d2"}
                    }, null, -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex justify-center mb-4" }, [
                      _createElementVNode("div", {
                        class: "h-14 w-14 rounded-full border-2 flex items-center justify-center",
                        style: {"border-color":"#1976d2"}
                      }, [
                        _createElementVNode("i", {
                          class: "pi pi-check font-bold",
                          style: {"color":"#1976d2","font-size":"30px"}
                        })
                      ])
                    ], -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-xl font-semibold text-darkblue" }, " System Activated Successfully ", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-gray-600 mt-2" }, " The system has been activated and is now running as expected. ", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.systemIcon)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.systemIcon,
                                class: "h-7 w-7 object-contain",
                                alt: ""
                              }, null, 8, _hoisted_9))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.systemNameInitial), 1))
                        ]),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.systemName || 'System'), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "success-active-badge" }, [
                          _createElementVNode("span", { class: "success-active-dot" }),
                          _createTextVNode(" Active ")
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "screenshot-btn-manage",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOk && _ctx.onOk(...args)))
                      }, " OK ")
                    ])
                  ]))
                : (_ctx.mode === 'tasks')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
                        _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0" }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "h-6 w-6",
                            alt: ""
                          })
                        ]),
                        _createElementVNode("div", { class: "flex-1" }, [
                          _createElementVNode("h3", { class: "text-xl font-semibold text-darkblue" }, " Tasks in progress ")
                        ])
                      ], -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "text-sm text-gray-600 mt-2" }, [
                          _createTextVNode(" By clicking on "),
                          _createElementVNode("b", null, "OK "),
                          _createTextVNode("button the following mentioned tasks in planner will be Terminated and the control will be deactivated. "),
                          _createElementVNode("br"),
                          _createTextVNode(" To stop click on "),
                          _createElementVNode("b", null, "CANCEL"),
                          _createTextVNode(" button.. ")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex items-center gap-4 px-4 py-2 bg-[#f9f9fb] border-b border-lightgrey sticky top-0" }, [
                            _createElementVNode("p", { class: "task-id-cell text-xs font-semibold tracking-wide text-placeholder uppercase" }, " Task Id "),
                            _createElementVNode("p", { class: "task-title-cell text-xs font-semibold tracking-wide text-placeholder uppercase" }, " Title "),
                            _createElementVNode("p", { class: "task-due-date-cell text-xs font-semibold tracking-wide text-placeholder uppercase" }, " Due Date ")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedTasks, (task, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: task.taskId || index,
                              class: _normalizeClass(["flex items-start gap-4 px-4 py-2.5 bg-white", index !== _ctx.normalizedTasks.length - 1 ? 'border-b border-lightgrey' : ''])
                            }, [
                              _createElementVNode("p", _hoisted_16, [
                                (task.href)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: task.href,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      class: "task-id-link",
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                    }, _toDisplayString(task.taskId), 9, _hoisted_17))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(task.taskId), 1))
                              ]),
                              _createElementVNode("p", _hoisted_19, _toDisplayString(task.taskTitle), 1),
                              _createElementVNode("p", _hoisted_20, _toDisplayString(task.dueDate), 1)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "screenshot-btn-cancel",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                        }, " Cancel "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "screenshot-btn-manage",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onOk && _ctx.onOk(...args)))
                        }, " OK ")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
                        _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0" }, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "h-6 w-6",
                            alt: ""
                          })
                        ]),
                        _createElementVNode("div", { class: "flex-1" }, [
                          _createElementVNode("h3", { class: "text-xl font-semibold text-darkblue" }, " Activate system? ")
                        ])
                      ], -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "text-sm text-gray-600 mt-2" }, " You cannot activate while System is Inactive. Resolve the System listed below, then continue. ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs font-semibold tracking-wide text-placeholder uppercase mb-2" }, " System ", -1)),
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeControls, (control, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: control._id || control.id || index,
                              class: _normalizeClass(["flex items-center gap-3 px-4 py-2.5 bg-white", index !== _ctx.activeControls.length - 1 ? 'border-b border-lightgrey' : ''])
                            }, [
                              _createElementVNode("div", _hoisted_25, [
                                (control.imageUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: control.imageUrl,
                                      class: "h-7 w-7 object-contain",
                                      alt: ""
                                    }, null, 8, _hoisted_26))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString((control.systemName || 'S').charAt(0).toUpperCase()), 1))
                              ]),
                              _createElementVNode("p", _hoisted_28, _toDisplayString(control.systemName), 1)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "screenshot-btn-cancel",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                        }, " Cancel "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "screenshot-btn-manage",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onManageControls && _ctx.onManageControls(...args)))
                        }, " Activate System ")
                      ])
                    ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}